// // src/hooks/useSessionTimeout.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useSessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const loginTime = Date.now();
    // const sessionDuration = 2 * 60 * 1000; // 2 minutes (testing ke liye)
    const sessionDuration = 8 * 60 * 60 * 1000; // 8 hours

    const timer = setTimeout(() => {
      localStorage.removeItem("token");
      alert("Session expired");
      navigate("/");
    }, sessionDuration);

    // Cleanup function
    return () => clearTimeout(timer);
  }, [navigate]);
};
